import { Capacitor } from '@capacitor/core'

declare global {
  interface Window {
    readonly phonicsDesktop?: Readonly<{ platform: 'windows'; version: string }>
  }
}

/** Presentation-only marker exposed by the isolated desktop preload; not a permission grant. */
export function isWindowsDesktop(): boolean {
  return typeof window !== 'undefined' && window.phonicsDesktop?.platform === 'windows' && typeof window.phonicsDesktop.version === 'string'
}

export function isPackagedApp(): boolean {
  return isWindowsDesktop() || Capacitor.isNativePlatform()
}
